export default __webpack_public_path__ + "static/img_8716-00311bb79735e033dcd798d84ce7961a.png";